import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Bid } from '../../types';

interface BidsState {
  bids: Bid[];
  currentBid: Bid | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: BidsState = {
  bids: [],
  currentBid: null,
  isLoading: false,
  error: null,
};

const bidsSlice = createSlice({
  name: 'bids',
  initialState,
  reducers: {
    setBids: (state, action: PayloadAction<Bid[]>) => {
      state.bids = action.payload;
    },
    updateBid: (state, action: PayloadAction<Bid>) => {
      const index = state.bids.findIndex((b) => b.id === action.payload.id);
      if (index !== -1) state.bids[index] = action.payload;
      if (state.currentBid?.id === action.payload.id) state.currentBid = action.payload;
    },
    setCurrentBid: (state, action: PayloadAction<Bid | null>) => {
      state.currentBid = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setBids, updateBid, setCurrentBid, setLoading, setError } = bidsSlice.actions;
export default bidsSlice.reducer;
